/**
 * Gliederung der Seitenleiste nach Abteilungen: CRM-Abteilung (CRM Dashboard, Anfragen, Live Chats, Angebote, Marketing), Aufträge (Auftragsmanagement), Personalmanagement (Mitarbeiter, Aufgaben,
 * Kalender, Schichtplanung und die Auftragsplanung), Stammdaten (Kontakte, Produkte, Dokumente), Finanzen, Betrieb und System. Ein Modul gehört in genau eine Gruppe, die Reihenfolge der Schlüssel ist die
 * Reihenfolge im Menü.
 * Eine Gruppe erscheint nur, wenn mindestens eines ihrer Module lizenziert ist und die Rolle es sehen darf.
 *
 * Benutzer, Einrichtung und Konto stehen nicht hier, sie liegen hinter dem Zahnrad und dem Namenssymbol (siehe AppShell).
 * Ein neues Modul trägt sich hier ein, sonst landet es unter „Weitere“.
 */
export interface NavGroup {
  key: string;
  label: string;
  modules: string[];
}

export const NAV_GROUPS: NavGroup[] = [
  { key: 'crm', label: 'CRM-Abteilung', modules: ['crm', 'inquiries', 'webchat', 'offers', 'marketing', 'vouchers'] },
  { key: 'orders', label: 'Aufträge', modules: ['orders', 'ridebook'] },
  { key: 'team', label: 'Personalmanagement', modules: ['hr', 'payroll', 'contracts', 'calendar', 'shifts'] },
  { key: 'master', label: 'Stammdaten', modules: ['contacts', 'products', 'documents'] },
  { key: 'finance', label: 'Finanzen', modules: ['invoices_out', 'invoices_in', 'financing', 'chart', 'reports'] },
  { key: 'operations', label: 'Betrieb', modules: ['fleet', 'inventory'] },
  { key: 'system', label: 'System', modules: ['imports'] },
];

/** Gruppe für Module, die in keiner der obigen Listen stehen */
export const NAV_FALLBACK: NavGroup = { key: 'other', label: 'Weitere', modules: [] };
